export default __webpack_public_path__ + "static/media/Path1223.b140d696.png";